<template>
  <div class="lista-produtos row containerListProduct ma-0" v-if="produtos.length > 0" style="display: flex; flex-wrap: wrap; gap: 23px; justify-content: center;">
    <div
      v-for="product in produtos"
      :key="product.id"
      style="flex: 2 1 calc(20% - 16px); min-width: 200px; max-width: 200px; box-sizing: border-box;"
    >
      <div class="card-product" style="display: flex; flex-wrap: wrap; align-items: stretch;">
        
        <!-- Imagem -->
        <div class="card-image col s12 pa-1">
          <img
            :src="`webapi/item/${product.id}/fotoLow`"
            alt="Imagem do produto"
            @error="handleImageError($event)"
            style="width: 100%; height: 90px; object-fit: contain; mix-blend-mode: darken;"
          />
        </div>

        <!-- Descrição -->
        <div class="card-description col s12 pa-1">
          <p class="grey-text ma-0" style="font-size: 0.9rem;"><strong>Cód.</strong> {{ product.sku }}</p>
          <p class="truncateActive ma-0 mb-1" style="height: 65px; word-break: break-word; text-align: left; font-size: 0.9rem;">
            {{ product.descricao || 'Sem descrição disponível.' }}
          </p>
        </div>

        <!-- Botão COMPRAR -->
        <div
          class="btn-flat center col s12 ma-0"
          :style="{ borderRadius: '8px', border: '2px solid', borderColor: primaryColor, display: 'flex', justifyContent: 'center' }"
          @click.prevent="$emit('comprar', product)"
        >
          <i class="material-icons prefix primary-color-text pr-1">shopping_cart</i>
          <a href="#" class="primary-color-text">COMPRAR</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Caso não haja produtos -->
  <div class="center" v-else>
    <p>Nenhum produto encontrado no momento.</p>
  </div>
</template>

<script>
export default {
  name: 'lista-produtos',
  props: {
    produtos: { type: Array, default: () => [] },
    primaryColor: { type: String, default: '#ccc' }
  },
  methods: {
    handleImageError(event) {
      event.target.src = 'webapi/resource/foto_indisponivel.png';
    }
  }
};
</script>

<style scoped>
.card-product {
  transition: box-shadow 0.2s ease;
}
.card-product:hover {
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); */
}
</style>


// WEBPACK FOOTER //
// ListaProdutos.vue?25af9a80